import {
  ENROLLMENT_DECISION_TYPES,
  ENROLLMENT_STATUSES,
  type EnrollmentDecisionType,
  type EnrollmentStatus,
} from '@ctms/contracts';

/**
 * Polish labels of the nine decision types of the participation panel
 * (issue #29 — approved wireframe
 * `spec/domains/patients-pathways/ui/treatment-decisions.ui.md`, gate of
 * 2026-10-21, recommendation 1: the Polish wording becomes canonical for the
 * panel). The `Record` type forces completeness through `tsc` — the same
 * convention as `ENROLLMENT_STATUS_LABELS`.
 *
 * The seven panel verbs feed the decision select; the qualification pair
 * belongs to the #30 dialog flow and only ever appears as a history row
 * (wireframe note 3 — the panel displays it, it never records it). The
 * negative qualification label is the symmetric derivation of the wireframe's
 * positive example („Kwalifikacja — pozytywna").
 */
export const DECISION_TYPE_LABELS: Record<EnrollmentDecisionType, string> = {
  [ENROLLMENT_DECISION_TYPES.ENROLL_IN_TREATMENT]: 'Włączenie do leczenia (randomizacja)',
  [ENROLLMENT_DECISION_TYPES.STAGE_IMPROVEMENT]:
    'Poprawa po indukcji — przejście do fazy podtrzymującej',
  [ENROLLMENT_DECISION_TYPES.STAGE_NO_IMPROVEMENT]:
    'Brak poprawy po indukcji — przejście do reindukcji',
  [ENROLLMENT_DECISION_TYPES.END_TREATMENT]: 'Zakończenie leczenia — przejście do obserwacji',
  [ENROLLMENT_DECISION_TYPES.WITHDRAW_CONSENT]: 'Wycofanie zgody / kryteria dyskontynuacji',
  [ENROLLMENT_DECISION_TYPES.END_FOLLOW_UP]: 'Zakończenie obserwacji',
  [ENROLLMENT_DECISION_TYPES.LOST_CONTACT]: 'Utrata kontaktu z pacjentem',
  [ENROLLMENT_DECISION_TYPES.QUALIFICATION_POSITIVE]: 'Kwalifikacja — pozytywna',
  [ENROLLMENT_DECISION_TYPES.QUALIFICATION_NEGATIVE]: 'Kwalifikacja — negatywna',
};

/**
 * Polish participation status names of the #29 panel (wireframe convention
 * R4, gate recommendation 1). Deliberately SEPARATE from
 * `ENROLLMENT_STATUS_LABELS`: the cockpit legend and the participant-list
 * filter keep the English clinical names per the customer decision of
 * 2026-10-14, while the participation panel and its history show the
 * approved Polish wording. When an i18n runtime is introduced, this map
 * becomes the `pl` namespace of the panel.
 */
export const PARTICIPATION_STATUS_LABELS: Record<EnrollmentStatus, string> = {
  [ENROLLMENT_STATUSES.PRE_SCREENING]: 'Przed kwalifikacją',
  [ENROLLMENT_STATUSES.PRE_SCREENING_FAILURE]: 'Niepowodzenie przed kwalifikacją',
  [ENROLLMENT_STATUSES.SCREENED]: 'Zakwalifikowany',
  [ENROLLMENT_STATUSES.SCREENING_FAILURE]: 'Niepowodzenie screeningu',
  [ENROLLMENT_STATUSES.ONGOING]: 'W leczeniu',
  [ENROLLMENT_STATUSES.WITHDRAWN]: 'Wycofany',
  [ENROLLMENT_STATUSES.FOLLOW_UP]: 'Obserwacja',
  [ENROLLMENT_STATUSES.COMPLETED]: 'Zakończony',
  [ENROLLMENT_STATUSES.LOST_TO_FOLLOW_UP]: 'Utracono kontakt',
};
